// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__27pYT","col":"Table_col__1TuUc","fulfillmentStatus":"Table_fulfillmentStatus__b1ScP","emailCol":"Table_emailCol__3IE2X"};